// Meridian's Orange Theme Creator palette with every color's hue rotated 6 degrees toward red. Lightness
// and saturation are unchanged, so each step keeps its contrast role (palette500 on white is 7.2:1).
const meridianOrangePalette = {
  _version: '1.0',
  _paletteBase: 'palette300',
  palette50: '#ffe1de',
  palette100: '#ffc9c3',
  palette200: '#ff9a8e',
  palette300: '#ff4d38',
  palette400: '#d6321d',
  palette500: '#ae1700',
  palette600: '#871000',
  palette700: '#670a00',
  palette800: '#4b0500',
  paletteMuted100: '#e8d4d2',
  paletteMuted200: '#d5b1ad',
  paletteMuted300: '#c28078',
  paletteMuted400: '#a0635c',
  paletteMuted500: '#804942',
  paletteMuted600: '#633731',
  paletteMuted700: '#4a2824',
} as const;

export default meridianOrangePalette;
